import { Injectable, Input } from "@angular/core";
import { FormControlStatus, FormGroup } from "@angular/forms";
import { EMutualfundsServiceCode } from "@common/models";
import { ResultService } from "@common/services";
import { TranslateService } from "@ngx-translate/core";
import { BaseFpxChangeHandler, BaseFpxComponentState, BaseFpxFormHelper } from "src/app/common/utils/base-fpx.form.component";
import { MutualFundsService } from "src/app/services/mutual-funds.service";
import { IOpenPurchaseOrder } from "../model/purchase-order.model";
import { PurchaseOrderService } from "./purchase-order.service";

export class PurchaseOrderState extends BaseFpxComponentState {
  activeAccountNumber:string;
  disableMode: boolean;
}

@Injectable()
export class PurchaseOrderHelper extends BaseFpxFormHelper<PurchaseOrderState> {
 
  resultDetails: { status: string; message: string; };


  constructor(private _purchaseOrderService: PurchaseOrderService,
    private _resultService: ResultService,
    private _mutualFundsService: MutualFundsService,
    private translate: TranslateService) {
    super(new PurchaseOrderState());
   // this.addChangeHandler("", this.doAccountValidation);
   this.addChangeHandler("accountNumber", this.doAccountNumberChange);
   this.addChangeHandler("noOfUnits", this.doAmountChange);
  }
 
  private doAccountNumberChange : BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup)=>{
    if (value) {
        this.state.activeAccountNumber = value;
    } else {
        this.state.activeAccountNumber = '';
    }
  
      formGroup.controls['noOfUnits'].reset();
      formGroup.controls['termsCondition'].reset();
   
  
    }
    doAmountChange: BaseFpxChangeHandler = (
      name: string,
      status: FormControlStatus,
      value: any,
      formGroup: FormGroup
    ) => {
      if (formGroup.get("noOfUnits").value == null || formGroup.get("noOfUnits").value == "" ) {
        formGroup
          .get("noOfUnits")
          .setErrors({ emptyValue: true }, { emitEvent: false });
      }
      else if( formGroup.get("noOfUnits").value == 0)
      {
        formGroup
        .get("noOfUnits")
        .setErrors({ zeroValue: true }, { emitEvent: false });
      }
    };
    

  fetchPurchaseOrderDetails(requestReference, formGroup: FormGroup) {
    this._purchaseOrderService.fetchPurchaseOrderDetails(requestReference).subscribe(
        (res: IOpenPurchaseOrder)=> {
            formGroup.patchValue({
                'accountNumber': res.accountNumber,
                'noOfUnits': res.noOfUnits,
                'termsCondition': '1'
            }, {emitEvent: false});
            formGroup.disable({emitEvent: false});
            this.state.disableMode=true;
        },
        (err)=> {

        }
    );
}

  public doConfirm(context: any, success: any, failure: any) {
    context = {
      ...context,
    }

    const payload: any = {};
    payload['mfpurchaseorder'] = context;
    this._purchaseOrderService.openPurchaseOrder(payload).subscribe(
      (res) => {
          let additionalFields = {
            'referenceNumber': res.refNo?res.refNo:res.inventoryNo
            }
            let productDesc = this._mutualFundsService.getMutualFundProductDetail(context.accountNumber).accountDetails[0].productName;
            this._resultService.setSuccess(
              res,
              this.translate.instant('RESULTPAGEMESSAGE.'+EMutualfundsServiceCode.PURCHASE_ORDER).replace('productDesc',productDesc),
              additionalFields
            );
            success(res);
      },
      (err) => {
        this._resultService.setFailure(
            err,
            true,
        );
        failure(err);
      }
    );
  }

  resetState(){
    this.state.disableMode=false;
  }
  }
